import React, { useEffect, useState } from 'react';
import { Heading } from '@abyss/web/ui/Heading';
import { Router } from '@abyss/web/ui/Router';
import { usePageDataStore } from '@src/store/common/PageDataStore';
import { usePageTitleStore } from '@src/store/common/PageTitleStore';

export const PageTitle = () => {
  const [title, setTitle] = useState<string | undefined>(undefined);
  const pageData = usePageDataStore((state) => state.pageData);
  const pageTitle = usePageTitleStore((state) => state.pageTitle);

  useEffect(() => {
    if (pageData && 'pageTitle' in pageData && pageData.pageTitle !== '') {
      setTitle(pageData.pageTitle);
    }
  }, [pageData]);

  useEffect(() => {
    if (pageTitle && 'title' in pageTitle && pageTitle.title !== '') {
      setTitle(pageTitle.title);
    }
  }, [pageTitle]);

  return (
    <React.Fragment>
      <Router.MetaTags title={title} />
      <Heading display="h3">{title}</Heading>
    </React.Fragment>
  );
};
